import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { AuthenticatedUser } from '@/application/authentication/types';
import { ActionStatus } from '@/application/types';
import { mediumMap, mediaServerUrl500 } from '@/helpers/data';
import { Medium } from '@/domain/types';
import ImageWithFallback from '@/domain/product-search/components/image-with-fallback/image-with-fallback.vue';
import { ProductIdentification, SearchType } from '../../types';

const authenticationState = namespace('authentication');
const productSearchState = namespace('productSearch');

@Component({
  components: {
    ImageWithFallback,
  },
})
export default class SearchResults extends Vue {

  @authenticationState.State
  user!: AuthenticatedUser;

  @productSearchState.State
  productIdentifications!: ProductIdentification[];

  @productSearchState.State
  getProductIdentificationsByEANStatus!: ActionStatus;

  @productSearchState.State
  getProductIdentificationsByProjectNumberStatus!: ActionStatus;

  @productSearchState.State
  lastSearchType!: SearchType;

  @productSearchState.State
  lastSearchTerm!: string;

  @productSearchState.State
  hasSearchBeenTriggered!: boolean;

  @productSearchState.State
  hasSearchResultedIn0Results!: boolean;

  mediaServerUrl500 = mediaServerUrl500;

  get title(): string {
    if (this.hasSearchBeenTriggered && this.lastSearchType === 'ean') {
      return `Produkte für EAN ${this.lastSearchTerm}`;
    }

    if (this.hasSearchBeenTriggered && this.lastSearchType === 'project') {
      return `Produkte für Projektnummer ${this.lastSearchTerm}`;
    }

    return 'Produktsuche';
  }

  get noResult(): string {
    if (this.lastSearchType === 'ean') {
      return 'Für diese EAN konnte kein Produkt gefunden werden!';
    }

    return 'Für diese Projektnummer konnte kein Produkt gefunden werden!';
  }

  get isLoading(): boolean {
    return this.getProductIdentificationsByEANStatus === ActionStatus.InProgress
      || this.getProductIdentificationsByProjectNumberStatus === ActionStatus.InProgress;
  }

  get isListShown(): boolean {
    return !this.isLoading && this.productIdentifications.length > 0;
  }

  get isEmptyStateShown(): boolean {
    return !this.isLoading && !this.hasSearchBeenTriggered;
  }

  get isNoResultsShown(): boolean {
    return !this.isLoading && this.hasSearchBeenTriggered && this.hasSearchResultedIn0Results;
  }

  translatedMedium(medium: Medium): string {
    return mediumMap[medium];
  }

}
